import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import "./fokeev-brand.css";
import "./design-tokens.css";
import "./paper-buttons.css";
import "./spacing.css";
import "./mobile-home.css";

const BootHandoff = () => {
  React.useLayoutEffect(() => {
    clearTimeout(window.__fokeevBootTimeout);
    document.documentElement.classList.remove('fokeev-client-boot', 'fokeev-hero-boot');
    document.getElementById('fokeev-boot-loader')?.remove();
  }, []);
  return null;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <BootHandoff />
    </HelmetProvider>
  </React.StrictMode>,
);
